import { useEffect, useState } from "react";
import { BaseClient } from "../../../../../Types/BaseClientManagement";

export const useClinicalImportConfigState = (client: BaseClient) => {
  const [dialpadApiKey, setDialpadApiKey] = useState(client.clinicalAnalyticsConfig?.dialpadApiKey ?? "");

  const [facebookAdAccountId, setFacebookAdAccountId] = useState(
    client.clinicalAnalyticsConfig?.facebookAdAccountId ?? "",
  );
  const [facebookApiKey, setFacebookApiKey] = useState(client.clinicalAnalyticsConfig?.facebookApiKey ?? "");
  const [qualtricsApiToken, setQualtricsApiToken] = useState(
    client.clinicalAnalyticsConfig?.qualtricsApiToken ?? "",
  );
  const [quickbaseApiToken, setQuickbaseApiToken] = useState(
    client.clinicalAnalyticsConfig?.quickbaseApiToken ?? "",
  );
  const [quickbaseRealmHostName, setQuickbaseRealmHostName] = useState(
    client.clinicalAnalyticsConfig?.quickbaseRealmHostName ?? "",
  );

  useEffect(() => {
    setDialpadApiKey(client.clinicalAnalyticsConfig?.dialpadApiKey);
    setFacebookAdAccountId(client.clinicalAnalyticsConfig?.facebookAdAccountId);
    setFacebookApiKey(client.clinicalAnalyticsConfig?.facebookApiKey);
    setQualtricsApiToken(client.clinicalAnalyticsConfig?.qualtricsApiToken);
    setQuickbaseApiToken(client.clinicalAnalyticsConfig?.quickbaseApiToken);
    setQuickbaseRealmHostName(client.clinicalAnalyticsConfig?.quickbaseRealmHostName);
  }, [client]);

  return {
    getters: {
      dialpadApiKey,
      facebookAdAccountId,
      facebookApiKey,
      qualtricsApiToken,
      quickbaseApiToken,
      quickbaseRealmHostName,
    },
    setters: {
      setDialpadApiKey,
      setFacebookAdAccountId,
      setFacebookApiKey,
      setQualtricsApiToken,
      setQuickbaseApiToken,
      setQuickbaseRealmHostName,
    },
  };
};
